export default {
  data() {
    return {
      sectionsList: [
        {
          name: 'Сервисы',
          isActive: false,
          itemsList: [
            {
              name: 'МТС\u00A0Линк Встречи',
              link: 'https://mts-link.ru/products/meetings/',
            },
            {
              name: 'МТС\u00A0Линк Вебинары',
              link: 'https://mts-link.ru/products/webinar/',
            },
            {
              name: 'МТС\u00A0Линк Курсы',
              link: 'https://mts-link.ru/products/westudy/',
            },
            {
              name: 'МТС\u00A0Линк Чаты',
              link: 'https://mts-link.ru/products/messenger/',
            },
            {
              name: 'МТС\u00A0Линк Доски',
              link: 'https://mts-link.ru/products/boards/',
            },
            {
              name: 'МТС\u00A0Линк Формы',
              link: 'https://mts-link.ru/products/forms/',
            },
          ],
        },
        {
          name: 'Решения',
          isActive: false,
          itemsList: [
            {
              name: 'ПО и оборудование для гибридных коммуникаций',
              link: 'https://mts-link.ru/products/software-and-equipment/',
            },
            { name: 'Серверное решение (МТС Линк on-premise)',
              link: 'https://mts-link.ru/products/on-premise/'
            },
            { name: 'Платформа COMDI для крупных онлайн-мероприятий',
              link: 'https://mts-link.ru/products/comdi/'
            },
          ],
        },
        {
          name: 'Отрасли',
          isActive: false,

          itemsList: [
            {
              name: 'Промышленность',
              link: 'https://mts-link.ru/task/industry/',
            },
            {
              name: 'Здравоохранение',
              link: 'https://mts-link.ru/task/healthcare/',
            },
            {
              name: 'Образование',
              link: 'https://mts-link.ru/task/obuchenie_studentov/',
            },
            {
              name: 'Госсектор',
              link: 'https://mts-link.ru/task/govermental/',
            },
            {
              name: 'Финансы',
              link: 'https://mts-link.ru/task/finance/',
            },
            {
              name: 'Retail и\u00A0FMCG',
              link: 'https://mts-link.ru/task/retail/',
            },
            {
              name: 'IT-компании',
              link: 'https://mts-link.ru/task/it/',
            },
            {
              name: 'Крупный бизнес',
              link: 'https://mts-link.ru/enterprise/',
            },
          ],
        },
        {
          name: 'Тарифы',
          isActive: false,

          itemsList: [
            {
              name: 'Все тарифы',
              link: 'https://mts-link.ru/tariffs/',
            },
            {
              name: 'Тариф Встречи\u00A0Basic',
              link: 'https://mts-link.ru/tariffs/meetings-basic/12/',
            },
            {
              name: 'Тариф Встречи\u00A0Pro',
              link: 'https://mts-link.ru/tariffs/meetings-pro/12/',
            },
            {
              name: 'Тариф Обучение Optimum\u00A030',
              link: 'https://mts-link.ru/tariffs/optimum-30/12/',
            },
            {
              name: 'Тариф Обучение Pro\u00A0150',
              link: 'https://mts-link.ru/tariffs/pro-150/12/',
            },
          ],
        },
        {
          name: 'Скачать',
          isActive: false,

          itemsList: [
            {
              name: 'Скачайте наши приложения',
              link: 'https://mts-link.ru/application/',
            },
          ],
        },
        {
          name: 'Компания',
          isActive: false,
          itemsList: [
            {
              name: 'О нас',
              link: 'https://mts-link.ru/about_service/',
            },
            {
              name: 'Пресс-центр',
              link: 'https://mts-link.ru/news/',
            },
            {
              name: 'Партнерская программа',
              link: 'https://mts-link.ru/partners/',
            },
            {
              name: 'Мероприятия',
              link: 'https://mts-link.ru/events-calendar/',
            },
            {
              name: 'Вакансии',
              link: 'https://job.mts-link.ru/vacancies',
            },
            {
              name: 'Контакты',
              link: 'https://mts-link.ru/contacts/',
            },
          ],
        },
        {
          name: 'Блог',
          isActive: false,
          itemsList: [
            {
              name: 'Все публикации',
              link: 'https://mts-link.ru/blog/',
            },
            {
              name: 'Публикации на\u00A0тему: Кейсы',
              link: 'https://mts-link.ru/blog/category/cases/',
            },
            {
              name: 'Публикации на\u00A0тему: Новости',
              link: 'https://mts-link.ru/blog/category/news/',
            },
            {
              name: 'Публикации на\u00A0тему: Удаленка',
              link: 'https://mts-link.ru/blog/category/remote-work/',
            },
            {
              name: 'Публикации на\u00A0тему: Коллеги',
              link: 'https://mts-link.ru/blog/category/colleagues/',
            },
            {
              name: 'Публикации на\u00A0тему: Технологии',
              link: 'https://mts-link.ru/blog/category/technologies/',
            },
            {
              name: 'Публикации на\u00A0тему: Бизнес',
              link: 'https://mts-link.ru/blog/category/business/',
            },
            {
              name: 'Публикации на\u00A0тему: Инфографика',
              link: 'https://mts-link.ru/blog/category/infografika/',
            },
            {
              name: 'Публикации на\u00A0тему: Инструкции',
              link: 'https://mts-link.ru/blog/category/instructions/',
            },
            {
              name: 'Публикации на\u00A0тему: Обучение',
              link: 'https://mts-link.ru/blog/category/education/',
            },
            {
              name: 'Публикации на\u00A0тему: Обучение сотрудников',
              link: 'https://mts-link.ru/blog/category/corp_education/',
            },
            {
              name: 'Публикации на\u00A0тему: Подборки',
              link: 'https://mts-link.ru/blog/category/sets/',
            },
            {
              name: 'Публикации на\u00A0тему: Подготовка к\u00A0вебинару',
              link: 'https://mts-link.ru/blog/category/podgotovka-k-vebinaru/',
            },
            {
              name: 'Публикации на\u00A0тему: Популярные',
              link: 'https://mts-link.ru/blog/popular/',
            },
          ],
        },
        {
          name: 'Дополнительно',
          isActive: false,
          itemsList: [
            {
              name: 'База знаний',
              link: 'https://help.mts-link.ru/',
            },
            {
              name: 'Поддержка 24/7',
              link: 'https://mts-link.ru/faq_and_support/',
            },
            {
              name: 'Обучающие материалы',
              link: 'https://learn.mts-link.ru/',
            },
            {
              name: 'Практическое пособие по\u00A0вебинарам',
              link: 'https://mts-link.ru/metodichka/',
            },
            {
              name: 'Проверка поддержки вашего браузера',
              link: 'https://status.mts-link.ru/',
            },
            {
              name: 'Bug Bounty',
              link: 'https://bugbounty.mts-link.ru/',
            },
          ],
        },
        {
          name: 'Политика и\u00A0комплаенс',
          isActive: false,
          itemsList: [
            {
              name: 'Деловая этика и\u00A0комплаенс',
              link: 'https://mts-link.ru/komplaens-i-delovaya-etika/',
            },
            {
              name: 'Политика в\u00A0отношении обработки персональных данных',
              link: 'https://mts-link.ru/privacy-policy/',
            },
            {
              name: 'Правовая информация',
              link: 'https://mts-link.ru/policy/',
            },
          ],
        },
        {
          name: 'Личный кабинет',
          isActive: false,
          itemsList: [
            {
              name: 'Вход в\u00A0ЛК',
              link: 'https://my.mts-link.ru/',
            },
            {
              name: 'Регистрация в платформе',
              link: 'https://mts-link.ru/user/organizer/',
            },
            {
              name: 'Записаться на демо',
              link: 'https://mts-link.ru/user/demo/',
            },
            {
              name: 'Регистрация участника',
              link: 'https://mts-link.ru/user/participant/',
            },
            {
              name: 'Тест системы',
              link: 'https://my.mts-link.ru/support/test/',
            },
          ],
        },
      ],
    }
  },
}
